import http from "@/services/http";

/**
 * Lista as condições/diagnósticos de um paciente (tabela única patient_conditions).
 * Pode filtrar por categoria para cada card: 'cid' | 'chronic' | 'psychological' | 'other'.
 *
 * @param {number|string} patientId
 * @param {string|null} category
 * @returns {Promise<object[]>}
 */
export async function getConditionsByPatient(patientId, category = null) {
  const config = category ? { params: { category } } : {};
  const { data } = await http.get(
    `/api/patient-conditions/get-by-patient/${patientId}`,
    config,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona uma ou várias condições de uma vez ao paciente.
 * Cada item deve trazer ao menos { description, category }.
 *
 * @param {number|string} patientId
 * @param {object[]} conditions
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function createConditions(patientId, conditions) {
  return http.post(`/api/patient-conditions/create`, {
    patient_id: patientId,
    conditions,
  });
}

/**
 * Remove uma condição do paciente (soft delete).
 * @param {number} id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function deleteCondition(id) {
  return http.delete(`/api/patient-conditions/delete/${id}`);
}
